/**
 * Formie Autocomplete Placeholder Fix
 * Copies placeholder from hidden input to gmp-place-autocomplete element
 */

export default function FormieAutocomplete() {
  const processed = new WeakSet()

  const copyPlaceholders = () => {
    document.querySelectorAll('gmp-place-autocomplete').forEach((gmp) => {
      if (processed.has(gmp)) return
      processed.add(gmp)
      const input = gmp.closest('.fui-address-auto-complete')?.querySelector('input[placeholder]')
      // Only set placeholder when there is no saved value — if there is one, Formie's own
      // overlay div (fui-autocomplete-placeholder) will display it and both would overlap.
      if (input?.placeholder && !input.value) {
        gmp.placeholder = input.placeholder
      }
    })
  }

  const init = () => {
    copyPlaceholders()
    // Keep observing — Formie creates elements asynchronously (one per field),
    // so we must not disconnect after the first element appears.
    const observer = new MutationObserver(copyPlaceholders)
    observer.observe(document.body, { childList: true, subtree: true })
  }

  if (customElements.get('gmp-place-autocomplete')) {
    init()
  } else {
    customElements.whenDefined('gmp-place-autocomplete').then(init)
  }
}
